<template>
  <header class="article__header">
    <img
      :class="large ? 'article__image-large' : 'article__image'"
      :src="icon"
      aria-hidden="true"
    />
    <h1 class="article__headline">
      <slot />
    </h1>
  </header>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    icon: { type: String },
    large: { type: Boolean },
  },
})
</script>

<style lang="scss" scoped>
.article__header {
  display: flex;
  align-items: center;
  margin-bottom: $spacer20;
  margin-top: $spacer20;

  @media (min-width: $bp-sm) {
    align-items: flex-start;
  }
}

.article__headline {
  margin-bottom: 0.5rem;
}

.article__image {
  height: 2.5rem;
  margin-right: $spacer10;

  @media (min-width: $bp-sm) {
    height: 3rem;
  }
}
.article__image-large {
  height: 11rem;
  margin-right: $spacer10;

  @media (min-width: $bp-sm) {
    height: 18rem;
  }
}
</style>